import {MessageToastType} from "./MessageToastType";

export class ToastInstance {

  private tmrId: number;

  constructor(private text: string, private type: MessageToastType, private onCancel: (ToastInstance) => void) {
    const timeout = type === MessageToastType.INFO ? 3000 : 7000;
    this.tmrId = window.setTimeout(() => this.close(), timeout);
  }

  get closed() {
    return !this.tmrId;
  }

  close() {
    if (this.tmrId) {
      window.clearTimeout(this.tmrId);
      this.tmrId = undefined;
      this.onCancel(this);
    }
  }

}
